import { useQuery } from '@tanstack/react-query';
import { fetchSalesOrderById } from '@/api/orders';

export const salesOrderDetailKeys = {
  detail: (id: string) => ['orders', 'sales', 'detail', id] as const,
};

export function useSalesOrderDetail(id: string) {
  return useQuery({
    queryKey: salesOrderDetailKeys.detail(id),
    queryFn: () => fetchSalesOrderById(id).then(res => res.data),
    staleTime: 30_000,
    enabled: !!id,
  });
}
